import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as JobsStore from '../../store/jobs';
import { JobContractorRequests } from '../../components/jobs/JobContractorRequests';
import { hasPermission } from '../../utils/security';
import { isJobHasContractorPropertyGroupType } from '../../models';
import * as ContractorsStore from '../../store/contractors';

export default connect(
    (state: ApplicationState) => ({
        ...JobsStore.plainActions,
        ...state.identity,
        ...state.user,
        activityTypes: state.user.activityTypes,
        moduleManager: state.modules.moduleManager,
        constants: state.constants,
        propertyGroupTypes: state.user.propertyGroupTypes.filter(isJobHasContractorPropertyGroupType),
        hasPermission: (p: string) => hasPermission(p, {
            user: state.identity?.user,
            work: state.user.work,
            explicit: true,
        }),
      legalForms: state.user.legalForms,
      ...ContractorsStore.plainActions,
    }),
    JobsStore.actionCreators,
)(JobContractorRequests as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
